// Utility function to format timestamps
export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  
  if (isToday) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  } else {
    return date.toLocaleDateString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  }
};

// Reaction types configuration
export const reactionTypes = [
  { icon: 'FaThumbsUp', key: 'like', color: '#4CAF50' },
  { icon: 'FaHeart', key: 'love', color: '#E91E63' },
  { icon: 'FaLaugh', key: 'laugh', color: '#FF9800' },
  { icon: 'FaSadTear', key: 'sad', color: '#2196F3' }
]; 